var map = {
	"./enterprise0.png": "p6Bx",
	"./enterprise1.png": "BEhJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KcVa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/enterprise.*\.png$
// module id = KcVa
// module chunks = 3